export { default } from "./withAdminPrivileges";
